import styled, { css } from 'styled-components';

export const PreferredStarWrapper = styled.div`
  cursor:pointer;
  &:focus {
    background: transparent;
  };
`;

export const StarIcon = styled.i`
  color: gray;
  ${props => props.isSelected && css`
  color: ${props.theme.colors.selectedColor};
  `}
  &:focus {
     outline: none;
  }
  ::selection{
    background: none;
  }
`;
